import _definePage_default_0 from '/_work/22/s/src/pages/account/login.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/_work/22/s/src/pages/claims-complaints/file-a-claim/index.vue?definePage&vue&lang.tsx'
import _definePage_default_3 from '/_work/22/s/src/pages/customer-support/confirm-existing-user.vue?definePage&vue&lang.tsx'
import _definePage_default_4 from '/_work/22/s/src/pages/new-user/index.vue?definePage&vue&lang.tsx'
import _definePage_default_5 from '/_work/22/s/src/pages/new-user/existing-customer.vue?definePage&vue&lang.tsx'
import _definePage_default_6 from '/_work/22/s/src/pages/new-user/new-customer.vue?definePage&vue&lang.tsx'

export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/_work/22/s/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/about',
    name: '/about',
    component: () => import('/_work/22/s/src/pages/about.vue'),
    /* no children */
  },
  {
    path: '/account',
    /* internal name: '/account' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: 'login',
          name: '/account/login',
          component: () => import('/_work/22/s/src/pages/account/login.vue'),
          /* no children */
        },
        _definePage_default_0
      ),
      {
        path: 'settings',
        name: '/account/settings',
        component: () => import('/_work/22/s/src/pages/account/settings.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/artworks',
    /* internal name: '/artworks' */
    /* no component */
    children: [
      {
        path: '',
        name: '/artworks/',
        component: () => import('/_work/22/s/src/pages/artworks/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/auth',
    /* internal name: '/auth' */
    /* no component */
    children: [
      {
        path: 'redirect',
        /* internal name: '/auth/redirect' */
        /* no component */
        children: [
          {
            path: 'login',
            name: '/auth/redirect/login',
            component: () => import('/_work/22/s/src/pages/auth/redirect/login.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/cart',
    /* internal name: '/cart' */
    /* no component */
    children: [
      {
        path: '',
        name: '/cart/',
        component: () => import('/_work/22/s/src/pages/cart/index.vue'),
        children: [
          {
            path: '',
            name: '/cart//',
            component: () => import('/_work/22/s/src/pages/cart/index/index.vue'),
            /* no children */
          },
          {
            path: 'order-review',
            name: '/cart//order-review',
            component: () => import('/_work/22/s/src/pages/cart/index/order-review.vue'),
            /* no children */
          },
          {
            path: 'shipment',
            name: '/cart//shipment',
            component: () => import('/_work/22/s/src/pages/cart/index/shipment.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/claims-complaints',
    /* internal name: '/claims-complaints' */
    /* no component */
    children: [
      {
        path: '',
        name: '/claims-complaints/',
        component: () => import('/_work/22/s/src/pages/claims-complaints/index.vue'),
        /* no children */
      },
      {
        path: 'confirmation',
        name: '/claims-complaints/confirmation',
        component: () => import('/_work/22/s/src/pages/claims-complaints/confirmation.vue'),
        /* no children */
      },
      {
        path: 'file-a-claim',
        /* internal name: '/claims-complaints/file-a-claim' */
        /* no component */
        children: [
          _mergeRouteRecord(
            {
              path: '',
              name: '/claims-complaints/file-a-claim/',
              component: () => import('/_work/22/s/src/pages/claims-complaints/file-a-claim/index.vue'),
              /* no children */
            },
            _definePage_default_2
          ),
          {
            path: 'complete',
            name: '/claims-complaints/file-a-claim/complete',
            component: () => import('/_work/22/s/src/pages/claims-complaints/file-a-claim/complete.vue'),
            /* no children */
          },
          {
            path: 'select-invoice',
            name: '/claims-complaints/file-a-claim/select-invoice',
            component: () => import('/_work/22/s/src/pages/claims-complaints/file-a-claim/select-invoice.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/customer-support',
    /* internal name: '/customer-support' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: 'confirm-existing-user',
          name: '/customer-support/confirm-existing-user',
          component: () => import('/_work/22/s/src/pages/customer-support/confirm-existing-user.vue'),
          /* no children */
        },
        _definePage_default_3
      )
    ],
  },
  {
    path: '/invoices',
    /* internal name: '/invoices' */
    /* no component */
    children: [
      {
        path: '',
        name: '/invoices/',
        component: () => import('/_work/22/s/src/pages/invoices/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/items',
    /* internal name: '/items' */
    /* no component */
    children: [
      {
        path: '',
        name: '/items/',
        component: () => import('/_work/22/s/src/pages/items/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/items/[id]',
        component: () => import('/_work/22/s/src/pages/items/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/new-user',
    /* internal name: '/new-user' */
    /* no component */
    children: [
      _mergeRouteRecord(
        {
          path: '',
          name: '/new-user/',
          component: () => import('/_work/22/s/src/pages/new-user/index.vue'),
          /* no children */
        },
        _definePage_default_4
      ),
      _mergeRouteRecord(
        {
          path: 'existing-customer',
          name: '/new-user/existing-customer',
          component: () => import('/_work/22/s/src/pages/new-user/existing-customer.vue'),
          /* no children */
        },
        _definePage_default_5
      ),
      _mergeRouteRecord(
        {
          path: 'new-customer',
          name: '/new-user/new-customer',
          component: () => import('/_work/22/s/src/pages/new-user/new-customer.vue'),
          /* no children */
        },
        _definePage_default_6
      )
    ],
  },
  {
    path: '/orders',
    /* internal name: '/orders' */
    /* no component */
    children: [
      {
        path: '',
        name: '/orders/',
        component: () => import('/_work/22/s/src/pages/orders/index.vue'),
        /* no children */
      },
      {
        path: 'full-truck-parameters',
        name: '/orders/full-truck-parameters',
        component: () => import('/_work/22/s/src/pages/orders/full-truck-parameters.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/profile',
    name: '/profile',
    component: () => import('/_work/22/s/src/pages/profile.vue'),
    children: [
      {
        path: '',
        name: '/profile/',
        component: () => import('/_work/22/s/src/pages/profile/index.vue'),
        /* no children */
      },
      {
        path: 'info',
        name: '/profile/info',
        component: () => import('/_work/22/s/src/pages/profile/info.vue'),
        /* no children */
      },
      {
        path: 'users',
        /* internal name: '/profile/users' */
        /* no component */
        children: [
          {
            path: '',
            name: '/profile/users/',
            component: () => import('/_work/22/s/src/pages/profile/users/index.vue'),
            /* no children */
          },
          {
            path: ':id',
            name: '/profile/users/[id]',
            component: () => import('/_work/22/s/src/pages/profile/users/[id].vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/purchase-statistics',
    /* internal name: '/purchase-statistics' */
    /* no component */
    children: [
      {
        path: '',
        name: '/purchase-statistics/',
        component: () => import('/_work/22/s/src/pages/purchase-statistics/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/users',
    /* internal name: '/users' */
    /* no component */
    children: [
      {
        path: ':id',
        name: '/users/[id]',
        component: () => import('/_work/22/s/src/pages/users/[id].vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

